import styled from 'styled-components';

const ShopForm = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    gap:  4rem;
    align-items: center;
`;

export default ShopForm;